import React from "react";
import { useNavigate } from "react-router-dom";

interface IProps {
  products: any
}

const BestSellings: React.FC<IProps> = ({ products }) => {

  const navigate = useNavigate();

  return (
    <div className=" grid grid-cols-2  gap-5 w-full ">
      {products?.slice(0, 4).map((item: any, index: number) => {
        return (
          <div onClick={() => navigate(`/product-detail/${item?.id}`)} key={index} className=" border rounded-full p-1 xl:p-2 flex items-center gap-x-1 bg-[#FFFFFF] hover:border-yellow-color hover:cursor-pointer transform duration-300 hover:shadow-sm hover:shadow-yellow-400">
            <div className=" border p-1 rounded-full">
              <img
                className=" w-9 h-9 rounded-full min-w-9 min-h-9"
                src={item.images[0]}
                alt="..."
              />
            </div>

            <div className=" text-[11px] xl:text-xs font-poppins">
              <div className=" font-semibold">{item?.name}</div>
              <div className=" font-extrabold tracking-wider text-[10px]">#{item?.code}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default BestSellings;
